import { Display2 } from '@sainsburys-tech/fable'
import React from 'react'

import { IOvenSettingDetail } from '../../types/IOvenSettingDetail'
// import OvenTypeDescription from './OvenTypeDescription'

interface IMixProps {
  plannerGroupName: string
  ovenSettingDetail?: IOvenSettingDetail
}

const WaveMixCardTitle = ({
  plannerGroupName,
  ovenSettingDetail,
}: IMixProps) => {
  return (
    <>
      <Display2 style={{ paddingBottom: '16px' }}>
        {!ovenSettingDetail
          ? plannerGroupName
          : ovenSettingDetail?.ovenSettingDescription}
      </Display2>

      {/* <OvenTypeDescription ovenSettingDetail={ovenSettingDetail} /> */}
    </>
  )
}

export default WaveMixCardTitle
